// Пилюля адресата — одна на все экраны (005: FR-033; T055; ux.md «Табеля», раздел 5: одно свойство
// — одна пилюля и один выбор везде): «Справочник», карточки записей, «Главная», «Контроль».
// Подпись — причина из addresseeReasonLabels контракта с заглавной: «Нет почты», «Адрес не
// подтверждён», «Нет основного куратора», «У документа нет зоны ответственности». Тон и значок
// дублируют слово (README «Табеля», «Цвет»): нет почты мешает рассылке — color-bad; адрес не
// подтверждён, нет основного куратора и нет зоны — color-warn, их решает контролёр; остальное
// нейтрально. Адресат есть — «Готов», color-ok.
//
// 006 (FR-010, FR-011, FR-013): «Руководитель не определён» — color-warn, его решает контролёр
// (основной куратор подразделения или организации); «Подразделение в архиве» — нейтрально.
import { addresseeReasonLabels } from '@kp/contracts';
import type { AddresseeReason } from '@kp/contracts';
import { Badge } from '@kp/ui';
import type { BadgeTone, LucideIcon } from '@kp/ui';
import {
  Archive,
  Ban,
  CircleCheck,
  CircleDashed,
  CircleHelp,
  MailWarning,
  MailX,
  MapPinOff,
  UserRoundSearch,
  UserRoundX,
} from '@kp/ui/icons';

export const addresseeReasonTones = {
  no_email: 'bad',
  email_unconfirmed: 'warn',
  archived: 'neutral',
  no_primary_curator: 'warn',
  not_addressee: 'neutral',
  unclear: 'neutral',
  unresolved: 'neutral',
  no_zone: 'warn',
  no_manager: 'warn',
  unit_archived: 'neutral',
} as const satisfies Record<AddresseeReason, BadgeTone>;

export const addresseeReasonIcons = {
  no_email: MailX,
  email_unconfirmed: MailWarning,
  archived: Archive,
  no_primary_curator: UserRoundX,
  not_addressee: Ban,
  unclear: CircleHelp,
  unresolved: CircleDashed,
  no_zone: MapPinOff,
  no_manager: UserRoundSearch,
  unit_archived: Archive,
} as const satisfies Record<AddresseeReason, LucideIcon>;

/** «нет почты» → «Нет почты»: причина на пилюле и в полосе карточки — с заглавной. */
export function reasonTitle(reason: AddresseeReason): string {
  const text = addresseeReasonLabels[reason];
  return text.charAt(0).toLocaleUpperCase('ru-RU') + text.slice(1);
}

/** Пилюля причины без адресата: «Нет почты», «Адрес не подтверждён». */
export function ReasonBadge({ reason }: { reason: AddresseeReason }) {
  return (
    <Badge
      tone={addresseeReasonTones[reason]}
      icon={addresseeReasonIcons[reason]}
      className="kp-addressee"
    >
      {reasonTitle(reason)}
    </Badge>
  );
}

/**
 * Адресат строкой справочника (ready и причина) или адресат упоминания (contracts, Addressee):
 * «Готов» или причина. Причины нет — упоминание ждёт решения.
 */
export interface AddresseeLike {
  ready: boolean;
  reason?: AddresseeReason | null;
}

export function AddresseeBadge({ addressee }: { addressee: AddresseeLike }) {
  if (addressee.ready) {
    return (
      <Badge tone="ok" icon={CircleCheck} className="kp-addressee">
        Готов
      </Badge>
    );
  }
  return <ReasonBadge reason={addressee.reason ?? 'unresolved'} />;
}
